/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import { toast } from 'react-toastify';
import moment from 'moment';
// API
import { getTeamFilter, getRepFilter, getSpecialtyFilter } from '../../../api/filterOptionsApi';
// Helper Functions
import {
  filterValue,
  filterTeamOptions,
  filterRepOptions,
  filterSpecialtyOptions,
} from '../../../helpers/filterFunctions';
import useSamplingContext from '../context/useSamplingContext';
import { getProductSamplingInventory } from '../../../api/weeklyProductReportApi';

function Filter() {
  const {
    setFilterForm,
    filterForm,
    defaultFilter,
    reportData,
    setReportData,
    totalData,
    setTotalData,
    getData,
    loading,
  } = useContext(useSamplingContext);

  const [teamOptions, setTeamOptions] = useState({ loading: false, items: [] });
  const [specialtyOptions, setSpecialtyOptions] = useState({ loading: false, items: [] });
  const [repOptions, setRepOptions] = useState({ loading: false, items: [] });

  const loadSpecialtyOptions = async () => {
    setSpecialtyOptions({
      ...specialtyOptions,
      loading: true,
    });
    const request = {
      team: filterValue(filterForm?.team),
      rep_id: filterValue(filterForm?.rep_id),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getSpecialtyFilter(request);
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = filterSpecialtyOptions(data);
      setSpecialtyOptions({
        ...specialtyOptions,
        loading: false,
        items: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };
  const loadTeamOptions = async () => {
    setTeamOptions({
      ...teamOptions,
      loading: true,
    });
    const request = {
      rep_id: filterValue(filterForm?.rep_id),
      specialties: filterValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getTeamFilter(request);
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = filterTeamOptions(data);
      setTeamOptions({
        ...teamOptions,
        loading: false,
        items: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };
  const loadRepOptions = async () => {
    setRepOptions({
      ...repOptions,
      loading: true,
    });
    const request = {
      team: filterValue(filterForm?.team),
      specialties: filterValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getRepFilter(request);
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions({
        ...repOptions,
        loading: false,
        items: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const handleChangeFilter = (row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const clearTarget = () => {
    setFilterForm(defaultFilter);
    setReportData([]);
    setTotalData([]);
  };

  const searchTarget = () => {
    getData(filterForm);
  };

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const request = {
        department: '',
        head_id: '',
        manager_id: '',
        rep_id: filterForm?.rep_id?.value,
        keyword: '',
        from: filterForm?.from,
        to: filterForm?.to,
        specialty: filterForm?.specialty?.value ? [filterForm?.specialty?.value] : [],
        team: filterForm?.team?.value ? [filterForm?.team?.value] : [],
      };
      const res = await getProductSamplingInventory(request);

      const { code, result } = res.data.response;
      if (code === '200') {
        window.location.href = result;
        toast.success(`Successfully downloaded file: ${res?.data?.response?.file_name}`);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  useEffect(() => {
    getData(filterForm);
  }, []);

  useEffect(() => {
    loadTeamOptions();
    loadSpecialtyOptions();
    loadRepOptions();
  }, [filterForm]);

  return (
    <Box sx={{ pl: 3, pr: 3, mt: 2 }}>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            id='team'
            fullWidth
            loading={teamOptions?.loading}
            options={teamOptions?.items}
            autoComplete
            disableClearable
            value={filterForm.team}
            onChange={(event, newValue) => {
              setFilterForm({
                ...filterForm,
                team: newValue,
              });
            }}
            renderInput={(params) => <TextField {...params} label='Team' fullWidth />}
            size='small'
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='specialty'
            disableClearable
            fullWidth
            loading={specialtyOptions?.loading}
            options={specialtyOptions?.items}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Specialty' />}
            size='small'
            value={filterForm?.specialty}
            onChange={(e, newValue) => handleChangeFilter(newValue, 'specialty')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            loading={repOptions?.loading}
            options={repOptions?.items}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MPR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <DatePicker
            label='from'
            views={['month', 'day', 'year']}
            value={filterForm?.from}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='From' size='small' fullWidth />}
            onChange={(newValue) => handleChangeFilter(newValue, 'from')}
          />
        </Grid>
        <Grid md={2}>
          <DatePicker
            label='to'
            views={['month', 'day', 'year']}
            value={filterForm?.to}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
            onChange={(newValue) => handleChangeFilter(newValue, 'to')}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchTarget}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={clearTarget}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
          <Button
            variant='contained'
            color='warning'
            onClick={handleExport}
            sx={{ marginLeft: '10px' }}
          >
            Export
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
export default Filter;
